import mapper from "../../services/ModelMapperService";
import {initializePendo} from "../../services/PendoHelper";
import {GET_USER_DETAILS_SUCCESS} from "../../actions/user/platformUserAction";
import {GET_ALL_PRODUCTS_SUCCESS} from "../../actions/product/productAction";

const initialState = {
    user: {
        id: "",
        customerName: "",
        fullName: "",
        initials: "",
        products: [],
        allClaims: []
    },
    allProducts: [],
    ready: false
};

export default function platformUserReducer(state = initialState, action) {
    switch (action.type) {

        case GET_USER_DETAILS_SUCCESS: {
            initializePendo(mapper.mapToPendoUserDataModel(action.user));
            return {
                ...state,
                    user: mapper.mapToCurrentUserModel(action.user)
            };
        }

        case GET_ALL_PRODUCTS_SUCCESS: {
            const allProducts = action.products.map(product => {
                return {
                    productId: product.id,
                    name: product.name,
                    displayName: product.displayName,
                    isBackendProduct: product.isBackendProduct,
                    icon: product.icon
                };
            });

            return {
                ...state,
                allProducts: allProducts,
                user: {
                    ...state.user,
                    products: mapper.mapUserProduct(allProducts, state.user.allClaims)
                }
            };
        }
        default:
            return state;

    }
}
